// Recharts' es-toolkit dependency uses this runtime API. Build targets only
// transform syntax, so install the fallback before importing the app.
if (typeof Object.hasOwn !== 'function') {
  Object.defineProperty(Object, 'hasOwn', {
    configurable: true,
    writable: true,
    value: function hasOwn(object: unknown, key: PropertyKey): boolean {
      return Object.prototype.hasOwnProperty.call(object, key);
    },
  });
}

export {};
